import { makeStyles } from '@material-ui/core/styles';

const MUTED = '#6b6b76';
const ACTIVE_GRADIENT = 'linear-gradient(90deg, #010134 0%, #0078ff 100%)';

export const useStyles = makeStyles(() => ({
    group: {
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: 999,
        backgroundColor: '#f0f0f3',
        padding: 4,
        gap: 4,
    },
    option: {
        appearance: 'none',
        border: 'none',
        cursor: 'pointer',
        borderRadius: 999,
        padding: '10px 24px',
        fontSize: 15,
        fontWeight: 600,
        letterSpacing: 0.2,
        backgroundColor: 'transparent',
        color: MUTED,
        transition: 'color 120ms ease',
        '&:focus-visible': {
            outline: '2px solid #2f6bff',
            outlineOffset: 2,
        },
    },
    optionActive: {
        background: ACTIVE_GRADIENT,
        color: '#ffffff',
    },
}));
